import {
  ref,
  reactive,
  getCurrentInstance,
  computed,
  onBeforeMount,
  watch,
} from "@vue/composition-api";
export default function useQuestionAnswer(props) {
  const vm = getCurrentInstance().proxy;
  const activeIndex = ref("");

  const componentData = reactive({
    type: "transition",
    name: "flip-list",
  });

  const onFormQuestion = (data) => {
    vm.$emit("onFormQuestion", data);
  };

  const onUploadImage = (image, formData) => {
    vm.$emit("onUploadImage", image, formData);
  };

  const onShowUploadImage = () => {
    vm.$emit("onShowUploadImage", true);
  };

  const onUploadImageChoice = (image, formData) => {
    vm.$emit("onUploadImageChoice", image, formData);
  };

  const onAddChoice = (question) => {
    vm.$emit("onAddChoice", question);
  };

  const onRemoveChoice = (index, choice) => {
    vm.$emit("onRemoveChoice", index, choice);
  };

  const onRemoveQuestion = (formQuestion) => {
    const index = props.formQuestion.indexOf(formQuestion);
    vm.$emit("onRemoveQuestion", index);
  };

  const onDuplicate = (element) => {
    const idx = props.formQuestion.indexOf(element);
    vm.$emit("onDuplicate", props.formQuestion[idx], idx, props.formQuestion);
  };

  return {
    componentData,
    activeIndex,
    onFormQuestion,
    onUploadImage,
    onShowUploadImage,
    onAddChoice,
    onUploadImageChoice,
    onRemoveChoice,
    onRemoveQuestion,
    onDuplicate,
  };
}
